import _ from 'lodash';
import { createSelector } from 'reselect';

const _scopedState = state => state.entities.pageTemplate;
const _pageTemplatesById = state => _scopedState(state).byId;

const pageTemplates = createSelector(_pageTemplatesById, pageTemplatesById => _.values(pageTemplatesById));

const isFetching = state => _scopedState(state).isFetching;

const pageTemplateById = (state, pageTemplateId) => _pageTemplatesById(state)[pageTemplateId];

const pageTemplateByValidFor = createSelector(
  [pageTemplates, (state, validFor) => validFor],
  (pageTemplates, validFor) => {
    return _.filter(pageTemplates, t => {
      t.validFor === validFor;
    });
  }
);

export default {
  pageTemplates,
  pageTemplateById,
  pageTemplateByValidFor,
  isFetching,
};
